import dayjs from "dayjs";

// Use the same local date as the date/time formatters, including around midnight.
export const groupContractHistoryByDate = (historyData) => {
  if (!Array.isArray(historyData)) return [];

  const groups = historyData.reduce((result, item) => {
    const date = item.changedAt ? dayjs(item.changedAt) : null;
    const dateKey = date?.isValid() ? date.format("YYYY-MM-DD") : "";
    if (!result[dateKey]) result[dateKey] = [];
    result[dateKey].push(item);
    return result;
  }, {});

  const timestamp = (value) => {
    const date = value ? dayjs(value) : null;
    return date?.isValid() ? date.valueOf() : 0;
  };

  return Object.entries(groups)
    .sort(([a], [b]) => b.localeCompare(a))
    .map(([dateKey, items]) => {
      const sortedItems = [...items].sort(
        (a, b) => timestamp(b.changedAt) - timestamp(a.changedAt),
      );

      return {
        id: `group_${dateKey}`,
        isGroup: true,
        dateKey,
        changedAt: dateKey,
        changeCount: sortedItems.length,
        entityTypes: [...new Set(sortedItems.map((item) => item.entityType))],
        changeTypes: [...new Set(sortedItems.map((item) => item.changeType))],
        changeType: `${sortedItems.length} thay đổi`,
        itemCode: "",
        itemName: "",
        fieldDisplayName: "",
        oldValue: "",
        newValue: "",
        changedBy: "",
        subRows: sortedItems.map((item, index) => ({
          ...item,
          id: `${dateKey}_${index}`,
          isGroup: false,
        })),
      };
    });
};
